import axios from "axios";

import grid_functions from "../validation/grid_functions";
import points_within_polygon from "@turf/points-within-polygon";
import centroid from "@turf/centroid";
import { bun_server } from "./baseUrl";
import generate_uuid from "../validation/generate_uuid";
import bbox from "@turf/bbox";
import area from "@turf/area";
import geojson_geometries_lookup from "geojson-geometries-lookup";
import manifest_demography from "../../Data/manifest_demography.json";
import { convert_error_to_object } from "../../Functions/basic/convert_error_to_object";

const { get_grids_in_polygon } = grid_functions;
const item_per_looping = 25;
const delay_virtual_template = 333;

/*RUN FORMULA LOCAL*/
export const run_site_selection = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "run_site_selection",
    });

    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_progress_poi",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_progress_demo",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_grid_group",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_formula",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_save_feature",
        value: 0,
      },
    });

    const array_actions = [
      () => dispatch(get_area()),
      () => dispatch(get_poi()),
      () => dispatch(run_grid()),
      () => dispatch(clear_grid_intersections()),
      () => dispatch(run_formula()),
      () => dispatch(show_top_result()),
    ];

    const delay_ms = 100;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));

    const parent_action = async () => {
      return array_actions.reduce(
        (prev_promise, action_fn, index) =>
          prev_promise.then((results) =>
            child_action(action_fn, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_action = async (action_fn, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            await action_fn();
          } catch (error) {
            throw error;
          }
        };
        return core_logic();
      });
    };
    await parent_action();

    dispatch({
      type: "clear_loading_action",
      payload: "run_site_selection",
    });
  } catch (error) {
    throw error;
  }
};

export const get_area = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "modal_error_area",
        value: false,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "error_object_area",
        value: {},
      },
    });

    dispatch({
      type: "set_loading_action",
      payload: "get_area",
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_progress_demo",
        value: 0,
      },
    });
    const state = getState();
    const { provinsi, kota, kecamatan, kelurahan } = state.insight_reducer;
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res_features_demography = await axios.get(
      bun_server +
        `/sini_v2/insight_demography?PROVINSI=${provinsi}&KABKOT=${kota}&KECAMATAN=${kecamatan}&DESA=${kelurahan}`,
      config
    );

    const features_demography = res_features_demography?.data || [];

    console.log("features_demography.length=", features_demography.length);
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_demography",
        value: features_demography,
      },
    });
    dispatch({
      type: "insight_update",
    });
    dispatch({
      type: "insight_fly_update",
    });
    dispatch({
      type: "clear_loading_action",
      payload: "get_area",
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_progress_demo",
        value: 100,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "step_ss",
        value: 1,
      },
    });
  } catch (error) {
    const error_object = convert_error_to_object(error);
    console.log("error_object=", error_object);
    dispatch({
      type: "clear_loading_action",
      payload: "get_area",
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "modal_error_area",
        value: true,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "error_object_area",
        value: error_object,
      },
    });
  }
};

export const get_poi = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_value_insight",
      payload: { key: "modal_error_poi", value: false },
    });
    dispatch({
      type: "set_value_insight",
      payload: { key: "error_object_poi", value: {} },
    });

    dispatch({
      type: "set_loading_action",
      payload: "get_poi",
    });

    // CONFIGURATION
    const CONCURRENT_REQUESTS = 5;
    const delay_grid = 0;
    const grid_per_looping = 100;
    const delay_poi = 0;
    const poi_per_looping = 5;

    const config = {
      headers: { accesstoken: localStorage.token_mapid },
    };
    const state = getState();
    const {
      features_demography,
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
    } = state.insight_reducer;

    const query = {
      request_id: generate_uuid(),
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
    };

    if (!features_demography?.length) throw new Error("Demography Empty");

    // --- TIMER 1: CALCULATION ---
    console.time("grid_calculation_time");

    // 1. Fast Grid Calculation (Map based)
    const grid_map = new Map();
    features_demography.forEach((feature) => {
      const geometry = feature.geometry;
      let polygons = [];
      if (geometry.type === "Polygon") polygons.push(geometry.coordinates);
      else if (geometry.type === "MultiPolygon")
        polygons = geometry.coordinates;

      polygons.forEach((poly_coords) => {
        const grids_in_feature = get_grids_in_polygon({
          polygon: poly_coords[0],
          grouping_number: 1000000,
        });
        const flat_grids = grids_in_feature.flat();
        flat_grids.forEach((grid) => {
          grid_map.set(`${grid.q}_${grid.r}`, grid);
        });
      });
    });

    const unique_grids = Array.from(grid_map.values());
    const grid_id_list = [];
    for (let i = 0; i < unique_grids.length; i += grid_per_looping) {
      grid_id_list.push(unique_grids.slice(i, i + grid_per_looping));
    }

    console.timeEnd("grid_calculation_time");
    // ---------------------------

    const geojson_demography = {
      type: "FeatureCollection",
      features: features_demography,
    };

    const total_poi = grid_id_list.length || 0;
    dispatch({
      type: "set_value_insight",
      payload: { key: "total_poi", value: total_poi },
    });

    // Storage for results
    let all_features_poi = [];

    // --- FIX START: Initialize a counter ---
    let completed_count = 0;
    // ---------------------------------------

    // --- CHILD FUNCTION (API LOGIC) ---
    const process_grid_batch = async (item, idx) => {
      if (delay_grid > 0) await new Promise((r) => setTimeout(r, delay_grid));

      try {
        // 1. Get Count
        const body = { array_grid: item, ...query };
        const res_count = await axios.post(
          bun_server + `/sini_v2/insight_poi/count`,
          body,
          config
        );
        const count_poi = res_count?.data || 0;

        // 2. Pagination Logic
        const pagination_array = [];
        const total_pages = Math.ceil(count_poi / poi_per_looping);
        for (let page = 0; page < total_pages; page++) {
          pagination_array.push({
            skip: page * poi_per_looping,
            limit: poi_per_looping,
          });
        }

        // 3. Get POI Details
        for (const pageItem of pagination_array) {
          if (delay_poi > 0) await new Promise((r) => setTimeout(r, delay_poi));

          body.skip = pageItem.skip;
          body.limit = pageItem.limit;

          const res_poi = await axios.post(
            bun_server + `/sini_v2/insight_poi`,
            body,
            config
          );
          const raw_points = res_poi?.data || [];

          // Client-side Filter
          const geojson_point = {
            type: "FeatureCollection",
            features: raw_points,
          };
          const filtered = points_within_polygon(
            geojson_point,
            geojson_demography
          );

          all_features_poi.push(...filtered.features);
        }

        // --- FIX START: Increment counter safely ---
        completed_count = completed_count + 1;

        dispatch({
          type: "set_value_insight",
          payload: { key: "current_progress_poi", value: completed_count },
        });
        // -------------------------------------------
      } catch (error) {
        console.error("Error processing batch", idx, error);
        // Optional: Even if it fails, you might want to increment progress
        // so the bar doesn't get stuck, or handle error state differently.
        completed_count = completed_count + 1;
        dispatch({
          type: "set_value_insight",
          payload: { key: "current_progress_poi", value: completed_count },
        });
      }
    };

    // --- TIMER 2: API FETCHING (PARALLEL) ---
    console.time("api_fetching_time");

    for (let i = 0; i < grid_id_list.length; i += CONCURRENT_REQUESTS) {
      const batch = grid_id_list.slice(i, i + CONCURRENT_REQUESTS);
      await Promise.all(
        batch.map((item, index) => process_grid_batch(item, i + index))
      );
    }

    console.timeEnd("api_fetching_time");
    // ----------------------------------------

    // FINAL STATE UPDATES
    dispatch({
      type: "set_value_insight",
      payload: { key: "features_poi", value: all_features_poi },
    });
    dispatch({
      type: "set_value_insight",
      payload: { key: "total_poi_initial", value: all_features_poi.length },
    });
    dispatch({ type: "insight_update" });

    // Ensure it hits exactly 100% at the end
    dispatch({
      type: "set_value_insight",
      payload: { key: "current_progress_poi", value: total_poi },
    });
    dispatch({ type: "clear_loading_action", payload: "get_poi" });
    dispatch({
      type: "set_value_insight",
      payload: { key: "step_ss", value: 2 },
    });
  } catch (error) {
    const error_object = convert_error_to_object(error);
    console.log("error_object=", error_object);
    dispatch({ type: "clear_loading_action", payload: "get_poi" });
    dispatch({
      type: "set_value_insight",
      payload: { key: "modal_error_poi", value: true },
    });
    dispatch({
      type: "set_value_insight",
      payload: { key: "error_object_poi", value: error_object },
    });
  }
};

export const run_grid = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "run_grid",
    });
    const state = getState();
    const { grid_mode } = state.insight_reducer;
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_grid",
        value: [],
      },
    });
    if (grid_mode === "square") {
      await dispatch(generate_square());
    } else {
      await dispatch(generate_hex());
    }
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "step_ss",
        value: 3,
      },
    });
  } catch (error) {}
};

export const generate_square = () => async (dispatch, getState) => {
  const state = getState();
  const {
    features_demography,
    grid_size_mode,
    grid_counts,
    grid_width_meters,
  } = state.insight_reducer;
  const geojson_demography = {
    type: "FeatureCollection",
    features: features_demography,
  };
  const total_square_meters = area(geojson_demography); //square meters
  dispatch({
    type: "set_value_insight",
    payload: {
      key: "total_square_meters",
      value: total_square_meters,
    },
  });
  let cell_width_meters, cell_height_meters;
  const [min_longitude, min_latitude, max_longitude, max_latitude] =
    bbox(geojson_demography);
  //width and height of the bounding box in degrees
  const width = max_longitude - min_longitude;
  const height = max_latitude - min_latitude;
  if (grid_size_mode === "count") {
    //convert width and height to approximate meters
    const width_meters = width * 111_000;
    const height_meters = height * 111_000;

    //calculate the bounding box area in square meters
    const bounding_box_area = width_meters * height_meters;

    //initial cell area based on bounding box area
    const initial_cell_area = bounding_box_area / grid_counts;

    //adjust the cell area to fit the demography area more accurately
    const adjusted_cell_area =
      initial_cell_area * (total_square_meters / bounding_box_area);
    cell_width_meters = Math.sqrt(adjusted_cell_area); //in meters
    cell_height_meters = cell_width_meters; //in meters
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "grid_width_meters_approx",
        value: parseInt(cell_width_meters),
      },
    });
  } else {
    cell_width_meters = grid_width_meters;
    cell_height_meters = grid_width_meters;
    const adjusted_cell_area = cell_width_meters * cell_height_meters;
    const grid_counts_approx = parseInt(
      total_square_meters / adjusted_cell_area
    );
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "grid_counts_approx",
        value: grid_counts_approx,
      },
    });
  }
  //convert cell width and height back to degrees for grid generation
  const cell_width_deg = cell_width_meters / 111_000;
  const cell_height_deg = cell_height_meters / 111_000;
  const features_grid_raw = []; //create the grid features
  const num_rows = Math.ceil(height / cell_height_deg);
  const num_cols = Math.ceil(width / cell_width_deg);
  for (let row = 0; row < num_rows; row++) {
    //loop through rows and columns to generate grid cells
    for (let col = 0; col < num_cols; col++) {
      const cell_min_longitude = min_longitude + col * cell_width_deg;
      const cell_min_latitude = min_latitude + row * cell_height_deg;
      const cellMaxLng = cell_min_longitude + cell_width_deg;
      const cellMaxLat = cell_min_latitude + cell_height_deg;

      //create the grid cell as a GeoJSON Polygon feature
      const cell_feature = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [cell_min_longitude, cell_min_latitude],
              [cellMaxLng, cell_min_latitude],
              [cellMaxLng, cellMaxLat],
              [cell_min_longitude, cellMaxLat],
              [cell_min_longitude, cell_min_latitude],
            ],
          ],
        },
        properties: {
          row,
          col,
        },
      };
      features_grid_raw.push(cell_feature);
    }
  }
  dispatch({
    type: "set_value_insight",
    payload: {
      key: "features_grid_raw",
      value: features_grid_raw,
    },
  });
};

export const generate_hex = () => async (dispatch, getState) => {
  const state = getState();
  const {
    features_demography,
    grid_size_mode,
    grid_counts,
    grid_width_meters,
  } = state.insight_reducer;
  const geojson_demography = {
    type: "FeatureCollection",
    features: features_demography,
  };
  const total_square_meters = area(geojson_demography); // in square meters
  dispatch({
    type: "set_value_insight",
    payload: {
      key: "total_square_meters",
      value: total_square_meters,
    },
  });
  const [min_longitude, min_latitude, max_longitude, max_latitude] =
    bbox(geojson_demography);

  //calculate the width and height of the bounding box in degrees
  const width = max_longitude - min_longitude;
  const height = max_latitude - min_latitude;

  //nilai yang akan tergantung logic grid_size_mode
  let hex_width, hex_height, hex_radius;
  if (grid_size_mode === "count") {
    //convert width and height to approximate meters
    const width_meters = width * 111_000;
    const height_meters = height * 111_000;

    //bounding box area in square meters
    const bounding_box_area = width_meters * height_meters;

    //initial cell area based on bounding box area
    const initial_cell_area = bounding_box_area / grid_counts;

    //adjust the cell area to fit the demography area more accurately (in meters)
    const adjusted_cell_area =
      initial_cell_area * (total_square_meters / bounding_box_area);
    hex_radius = Math.sqrt((2 * adjusted_cell_area) / (3 * Math.sqrt(3)));
    hex_width = 2 * hex_radius; //horizontal distance across hexagon
    hex_height = Math.sqrt(3) * hex_radius; //vertical distance across hexagon
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "grid_width_meters_approx",
        value: parseInt(hex_width),
      },
    });
  } else {
    hex_width = grid_width_meters;
    hex_radius = hex_width / 2;

    // Vertical distance across hexagon
    hex_height = Math.sqrt(3) * hex_radius;
    const adjusted_cell_area =
      ((3 * Math.sqrt(3)) / 8) * Math.pow(hex_width, 2);
    const grid_counts_approx = parseInt(
      total_square_meters / adjusted_cell_area
    );
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "grid_counts_approx",
        value: grid_counts_approx,
      },
    });
  }

  //convert hex width and height back to degrees for grid generation
  const hex_width_deg = hex_width / 111_000;
  const hex_height_deg = hex_height / 111_000;
  const features_grid_raw = []; //create the hexagonal grid features
  const num_rows = Math.ceil(height / hex_height_deg);

  // offset columns by 3/4 width for hex pattern
  const num_cols = Math.ceil(width / (hex_width_deg * 0.75));
  for (let row = 0; row < num_rows; row++) {
    //loop through rows and columns to generate hexagonal grid cells
    for (let col = 0; col < num_cols; col++) {
      // Calculate hex center position
      const center_longitude = min_longitude + col * hex_width_deg * 0.75;
      let center_lat = min_latitude + row * hex_height_deg;

      //offset every second row by half the hex width to create the staggered hex pattern
      if (col % 2 === 1) {
        center_lat += hex_height_deg / 2;
      }
      //define hexagon points based on center point and hex radius
      const hex_points = [];
      for (let i = 0; i < 6; i++) {
        //60 degrees for each hex side
        const angle = (Math.PI / 3) * i;
        const point_longitude =
          center_longitude + (hex_radius / 111_000) * Math.cos(angle);
        const point_latitude =
          center_lat + (hex_radius / 111_000) * Math.sin(angle);
        hex_points.push([point_longitude, point_latitude]);
      }
      hex_points.push(hex_points[0]); //close the polygon

      //Create the hex cell as a GeoJSON Polygon feature
      const cell_feature = {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [hex_points],
        },
        properties: {
          row,
          col,
        },
      };
      features_grid_raw.push(cell_feature);
    }
  }
  dispatch({
    type: "set_value_insight",
    payload: {
      key: "features_grid_raw",
      value: features_grid_raw,
    },
  });
};

export const clear_grid_intersections = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const {
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
      features_grid_raw,
      features_demography,
      features_poi,
    } = state.insight_reducer;
    const geojson_poi = {
      type: "FeatureCollection",
      features: features_poi,
    };
    const delay_milisecond_constant = 77;
    const delay_promise = () =>
      new Promise((res) => setTimeout(res, delay_milisecond_constant));
    const total_item = features_grid_raw.length;
    const group_per_looping = [];
    const geojson_demography = {
      type: "FeatureCollection",
      features: features_demography,
    };
    const glookup = new geojson_geometries_lookup(geojson_demography);
    function get_mid_point(coordinates) {
      const numPoints = coordinates.length;
      let lat_sum = 0;
      let long_sum = 0;

      //sum all latitude and longitude values of the vertices
      coordinates.forEach(([longitude, latitude]) => {
        lat_sum += latitude;
        long_sum += longitude;
      });

      //calculate the average to get the center point
      const lat_center = lat_sum / numPoints;
      const long_center = long_sum / numPoints;
      return {
        type: "Point",
        coordinates: [long_center, lat_center],
      };
    }
    for (let i = 0; i < total_item; i += item_per_looping) {
      group_per_looping.push({
        start: i,
        end: Math.min(i + item_per_looping, total_item),
      });
    }
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_grid_group",
        value: 0,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "total_grid_group",
        value: group_per_looping.length,
      },
    });
    const parent_function = () => {
      return group_per_looping.reduce(
        (last_promise, range, index) =>
          last_promise.then((result_sum) =>
            child_function(range, index).then((result_current) => [
              ...result_sum,
              result_current,
            ])
          ),
        Promise.resolve([])
      );
    };
    const child_function = async (range, index) => {
      return delay_promise().then(() => {
        const core_function = async () => {
          try {
            const items = features_grid_raw.slice(range.start, range.end);
            items.forEach((feature_grid) => {
              //Pass entire coordinates array
              const grid_geojson = get_mid_point(
                feature_grid.geometry.coordinates[0]
              );
              const geojson_filtered = glookup.getContainers(grid_geojson);
              if (geojson_filtered?.features?.length > 0) {
                //step 1: demography --> next interpolate by area grid vs area DESA
                const properties_demography =
                  geojson_filtered?.features?.[0]?.properties || {};

                //step 2: poi
                const geojson_poi_inside = points_within_polygon(
                  geojson_poi,
                  feature_grid
                );
                const features_poi_inside = geojson_poi_inside?.features || [];
                const ALL_POI_COUNT = geojson_poi_inside?.features?.length || 0;
                let properties_poi = {};
                if (tipe_level === "tipe_1" || tipe_1_all) {
                  tipe_1_array.forEach((item) => {
                    const features_poi_inside_type = features_poi_inside.filter(
                      (feature) => {
                        return feature.properties.TIPE_1 === item.TIPE_1;
                      }
                    );
                    const value = features_poi_inside_type.length;
                    const key = item.TIPE_1;
                    properties_poi[key] = value;
                  });
                } else if (tipe_level === "tipe_2") {
                  tipe_2_array.forEach((item) => {
                    const features_poi_inside_type = features_poi_inside.filter(
                      (feature) => {
                        return (
                          feature.properties.TIPE_1 === item.TIPE_1 &&
                          feature.properties.TIPE_2 === item.TIPE_2
                        );
                      }
                    );
                    const value = features_poi_inside_type.length;
                    const key = item.TIPE_2 + ", " + item.TIPE_1;
                    properties_poi[key] = value;
                  });
                } else if (tipe_level === "tipe_3") {
                  tipe_3_array.forEach((item) => {
                    const features_poi_inside_type = features_poi_inside.filter(
                      (feature) => {
                        return (
                          feature.properties.TIPE_1 === item.TIPE_1 &&
                          feature.properties.TIPE_2 === item.TIPE_2 &&
                          feature.properties.TIPE_3 === item.TIPE_3
                        );
                      }
                    );
                    const value = features_poi_inside_type.length;
                    const key =
                      item.TIPE_3 + ", " + item.TIPE_2 + ", " + item.TIPE_1;
                    properties_poi[key] = value;
                  });
                }
                feature_grid.properties = {
                  ...feature_grid.properties,
                  ...properties_demography,
                  ...properties_poi,
                  ALL_POI_COUNT,
                };
                dispatch({
                  type: "push_value_insight",
                  payload: {
                    key: "features_grid",
                    value: feature_grid,
                  },
                });
              }
            });
            dispatch({
              type: "set_value_insight",
              payload: {
                key: "current_grid_group",
                value: index + 1,
              },
            });
          } catch (error) {}
        };
        return core_function();
      });
    };
    await parent_function();
    dispatch({
      type: "insight_update",
    });
    const { features_grid } = state.insight_reducer;
    if (features_grid.length > 0) {
      dispatch({
        type: "set_value_insight",
        payload: {
          key: "grid_counts",
          value: features_grid.length,
        },
      });
    }
    dispatch({
      type: "clear_loading_action",
      payload: "run_grid",
    });
  } catch (error) {}
};

export const run_formula = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "run_formula",
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_formula",
        value: 0,
      },
    });
    await new Promise((resolve) => setTimeout(resolve, 300));
    const state = getState();
    const { features_grid, array_formula_insight, config_final_score } =
      state.insight_reducer;
    function get_textual_score(score) {
      if (score >= 80) return "Sangat Sesuai";
      if (score >= 60) return "Sesuai";
      if (score >= 40) return "Cukup Sesuai";
      if (score >= 20) return "Tidak Sesuai";
      return "Sangat Tidak Sesuai";
    }
    const sum_array = array_formula_insight.map((item) => item.weight_score);
    const total_weight_score = sum_array.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    config_final_score.total_weight_score = total_weight_score;

    // Add delay after initial calculations
    await new Promise((resolve) => setTimeout(resolve, 200));
    array_formula_insight.forEach((formula) => {
      const { weight_score } = formula;
      let array_value = [];
      features_grid.forEach((feature) => {
        const value = feature?.properties?.[formula.key] || 0;
        array_value.push(value);
      });
      const min_raw = Math.min(...array_value);
      const max_raw = Math.max(...array_value);
      formula.min_raw = min_raw;
      formula.max_raw = max_raw;
      features_grid.forEach((feature) => {
        const value = feature.properties[formula.key] || 0;

        //Step 1: Normalisasi
        let normalized_value;
        if (formula.is_directly_proportional) {
          normalized_value = (value - min_raw) / (max_raw - min_raw);
        } else {
          normalized_value = 1 - (value - min_raw) / (max_raw - min_raw);
        }
        feature.properties[formula.key + "_NORMAL"] = normalized_value;

        //Step 2: Melibatkan bobot
        const weighted_value =
          (weight_score / total_weight_score) * normalized_value;
        feature.properties[formula.key + "_WEIGHTED"] = weighted_value;
      });
    });

    // Add delay after normalization and weighting
    await new Promise((resolve) => setTimeout(resolve, 250));

    // First loop: Sum weighted values and calculate min/max weighted values
    let min_weighted = Infinity;
    let max_weighted = -Infinity;

    features_grid.forEach((feature) => {
      let total_weighted = 0;

      // Sum the weighted values for each formula
      array_formula_insight.forEach((formula) => {
        const weighted_value =
          feature.properties[formula.key + "_WEIGHTED"] || 0;
        total_weighted += weighted_value;
      });

      // Store the total weighted value for the feature
      feature.properties["TOTAL_WEIGHTED"] = total_weighted;

      // Update the min and max weighted values
      if (total_weighted < min_weighted) {
        min_weighted = total_weighted;
        config_final_score.min_weighted = min_weighted;
      }
      if (total_weighted > max_weighted) {
        max_weighted = total_weighted;
        config_final_score.max_weighted = max_weighted;
      }
    });

    // Add delay after first loop
    await new Promise((resolve) => setTimeout(resolve, 200));

    // Second loop: Normalize, calculate percentage, and assign textual score
    features_grid.forEach((feature) => {
      const total_weighted = feature.properties["TOTAL_WEIGHTED"] || 0;

      // Step 1: Normalize the total weighted value to the range [0, 1]
      let normalized_score =
        (total_weighted - min_weighted) / (max_weighted - min_weighted);

      // Step 2: Convert normalized score into a percentage (0-100)
      const percentage_score = normalized_score * 100;

      // Step 3: Get the textual score based on the percentage
      const textual_score = get_textual_score(percentage_score);

      // Step 4: Store the final values in the feature's properties
      feature.properties["NORMALIZE_SCORE"] = normalized_score;
      feature.properties["FINAL_NUMBER_SCORE"] = percentage_score;
      feature.properties["FINAL_STATUS_SCORE"] = textual_score;
    });

    features_grid.sort((a, b) => {
      const scoreA = a?.properties?.["NORMALIZE_SCORE"] ?? 0;
      const scoreB = b?.properties?.["NORMALIZE_SCORE"] ?? 0;
      return scoreB - scoreA; // big to small
    });

    // Add delay before dispatching results
    await new Promise((resolve) => setTimeout(resolve, 250));
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_grid",
        value: features_grid,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "array_formula_insight",
        value: array_formula_insight,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "config_final_score",
        value: config_final_score,
      },
    });
    dispatch({
      type: "insight_update",
    });

    // Final delay before clearing loading
    await new Promise((resolve) => setTimeout(resolve, 200));
    dispatch({
      type: "clear_loading_action",
      payload: "run_formula",
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "current_formula",
        value: 100,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "step_ss",
        value: 4,
      },
    });
  } catch (error) {}
};

export const show_top_result = (body) => async (dispatch, getState) => {
  try {
    const state = getState();
    let { features_grid } = state.insight_reducer;
    const { top_result_limit } = state.insight_reducer;
    features_grid = features_grid.sort(
      (a, b) =>
        b.properties.FINAL_NUMBER_SCORE - a.properties.FINAL_NUMBER_SCORE
    );
    features_grid = features_grid.map((feature, index) => {
      feature.key = String(index + 1);
      feature.properties.index = index + 1;
      return feature;
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_grid",
        value: features_grid,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_grid_filtered",
        value: features_grid,
      },
    });
    const features_top = features_grid.slice(0, top_result_limit);
    const features_centroid_sample = features_top.map((feature) => {
      const point = centroid(feature);
      point.properties = feature.properties;
      point.feature_polygon = feature;
      return point;
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_centroid_sample",
        value: features_centroid_sample,
      },
    });

    dispatch({
      type: "set_value_insight",
      payload: {
        key: "is_show_top_result",
        value: true,
      },
    });
    dispatch({
      type: "insight_update",
    });

    if (!body.ignore_modal) {
      dispatch({
        type: "set_value_insight",
        payload: {
          key: "modal_ss_done",
          value: true,
        },
      });
    }
  } catch (error) {}
};

export const show_top_result_saved = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const { top_result_limit } = state.insight_reducer;
    const { geo_layer_list, layer_id } = state.layer;
    const geo_layer = geo_layer_list.find(
      (item) => item?.geo_layer?._id === layer_id
    )?.geo_layer;
    let features_grid = geo_layer?.geojson?.features || [];
    features_grid = features_grid.sort(
      (a, b) =>
        b.properties.FINAL_NUMBER_SCORE - a.properties.FINAL_NUMBER_SCORE
    );
    features_grid = features_grid.map((feature, index) => {
      feature.properties.index = index + 1;
      return feature;
    });

    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_grid_saved",
        value: features_grid,
      },
    });

    const features_top = features_grid.slice(0, top_result_limit);
    const features_centroid_sample = features_top.map((feature) => {
      const point = centroid(feature);
      point.properties = feature.properties;
      point.feature_polygon = feature;
      return point;
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "features_centroid_sample",
        value: features_centroid_sample,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "is_show_top_result",
        value: true,
      },
    });
    dispatch({
      type: "insight_update",
    });
  } catch (error) {}
};

/*CRUD TEMPLATE*/
export const create_formula = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "create_formula",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    await axios.post(
      bun_server + "/sini_v2/ss_formula/create_formula",
      body,
      config
    );
    dispatch({
      type: "clear_loading_action",
      payload: "create_formula",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "create_formula",
    });
  }
};

export const get_formula_mapid = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_formula_mapid",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.get(
      bun_server + "/sini_v2/ss_formula/get_formula_mapid",
      config
    );
    const data = res?.data || [];
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "formula_mapid_list",
        value: data,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "get_formula_mapid",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_formula_mapid",
    });
  }
};

export const get_formula_user = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_formula_user",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.get(
      bun_server + "/sini_v2/ss_formula/get_formula_user",
      config
    );
    const data = res?.data || [];
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "formula_user_list",
        value: data,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "get_formula_user",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_formula_user",
    });
  }
};

export const delete_formula = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "delete_formula",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const state = getState();
    let { formula_selected, formula_user_list } = state.insight_reducer;
    const request_id = formula_selected?.request_id;
    if (!request_id) throw new Error("Request id is required");
    await axios.delete(
      bun_server +
        `/sini_v2/ss_formula/delete_formula?request_id=${request_id}`,
      config
    );
    formula_user_list = formula_user_list.filter(
      (item) => item.request_id !== request_id
    );
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "formula_user_list",
        value: formula_user_list,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "delete_formula",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "delete_formula",
    });
  }
};

export const update_formula = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "update_formula",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const state = getState();
    let { formula_selected } = state.insight_reducer;
    await axios.put(
      bun_server + "/sini_v2/ss_formula/update_formula",
      formula_selected,
      config
    );
    dispatch({
      type: "clear_loading_action",
      payload: "update_formula",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "update_formula",
    });
  }
};

/*RUN TEMPLATE SITE SELECTION*/
export const run_template = (formula_selected_run) => async (dispatch) => {
  try {
    const array_actions = [
      () => dispatch(set_formula_selected_run(formula_selected_run)),
      () => dispatch(template_poi()),
      () => dispatch(template_demo()),
      () => dispatch(show_template_formula()),
    ];

    const delay_ms = 0;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));

    const parent_action = () => {
      return array_actions.reduce(
        (prev_promise, action_fn, index) =>
          prev_promise.then((results) =>
            child_action(action_fn, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };

    const child_action = async (action_fn, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            await action_fn();
          } catch (error) {
            throw error;
          }
        };
        return core_logic();
      });
    };

    await parent_action(() => {});
  } catch (error) {
    throw error;
  }
};

export const set_formula_selected_run =
  (formula_selected_run) => async (dispatch) => {
    try {
      dispatch({
        type: "set_loading_action",
        payload: "set_formula_selected_run",
      });
      await new Promise((resolve) =>
        setTimeout(resolve, delay_virtual_template)
      );
      dispatch({
        type: "set_value_insight",
        payload: {
          key: "formula_selected_run",
          value: formula_selected_run,
        },
      });
      dispatch({
        type: "set_value_insight",
        payload: {
          key: "modal_run_template",
          value: false,
        },
      });
      dispatch({
        type: "set_value_insight",
        payload: {
          key: "menu_formula",
          value: "manual",
        },
      });
      dispatch({
        type: "clear_loading_action",
        payload: "set_formula_selected_run",
      });
    } catch (error) {}
  };

export const template_poi = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "template_poi",
    });
    await new Promise((resolve) => setTimeout(resolve, delay_virtual_template));
    const state = getState();
    let { formula_selected_run } = state.insight_reducer;
    const { tipe_level, tipe_1_array, tipe_2_array, tipe_3_array, tipe_1_all } =
      formula_selected_run;
    const object_data = {
      tipe_level,
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_1_all,
    };
    Object.entries(object_data).forEach(([key, value]) => {
      dispatch({
        type: "set_value_insight",
        payload: {
          key,
          value,
        },
      });
    });
    await new Promise((resolve) => setTimeout(resolve, delay_virtual_template));
    dispatch({
      type: "clear_loading_action",
      payload: "template_poi",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "template_poi",
    });
  }
};

export const template_demo = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "template_demo",
    });
    const state = getState();
    await new Promise((resolve) => setTimeout(resolve, delay_virtual_template));
    let { formula_selected_run } = state.insight_reducer;
    const { array_formula_insight } = formula_selected_run;
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "array_formula_insight",
        value: array_formula_insight,
      },
    });
    await new Promise((resolve) => setTimeout(resolve, delay_virtual_template));
    dispatch({
      type: "clear_loading_action",
      payload: "template_demo",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "template_demo",
    });
  }
};

export const show_template_formula = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "template_formula",
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "is_show_formula",
        value: false,
      },
    });
    await new Promise((resolve) => setTimeout(resolve, delay_virtual_template));
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "is_show_formula",
        value: true,
      },
    });
    await new Promise((resolve) => setTimeout(resolve, delay_virtual_template));
    dispatch({
      type: "clear_loading_action",
      payload: "template_formula",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "template_formula",
    });
  }
};

/*RUN AI PROMPT SITE SELECTION*/
export const run_ai_site_selection = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "menu_formula",
        value: "manual",
      },
    });
    const array_actions = [
      () => dispatch(gen_poi_ss()),
      () => dispatch(gen_demo_ss()),
      () => dispatch(show_template_formula()),
    ];
    const delay_ms = 0;
    const delay_promise = () =>
      new Promise((resolve) => setTimeout(resolve, delay_ms));
    const parent_action = async () => {
      return array_actions.reduce(
        (prev_promise, action_fn, index) =>
          prev_promise.then((results) =>
            child_action(action_fn, index).then((result) => [
              ...results,
              result,
            ])
          ),
        Promise.resolve([])
      );
    };
    const child_action = async (action_fn, index) => {
      return delay_promise().then(() => {
        const core_logic = async () => {
          try {
            await action_fn();
          } catch (error) {
            throw error;
          }
        };
        return core_logic();
      });
    };
    await parent_action();
  } catch (error) {
    throw error;
  }
};

export const gen_poi_ss = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "template_poi",
    });
    const state = getState();
    const { prompt_ss, list_tipe_3 } = state.insight_reducer;
    const body = {
      prompt_ss,
      list_tipe_3,
    };
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/ss_formula/gen_poi_ss`,
      body,
      config
    );
    const data = res?.data;
    const result = data?.result || [];
    const response = data?.response || "";
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "response_ai_poi",
        value: response,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "tipe_level",
        value: "tipe_3",
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "tipe_1_array",
        value: [],
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "tipe_2_array",
        value: [],
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "tipe_3_array",
        value: result,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "tipe_1_all",
        value: false,
      },
    });
    const array_formula_insight = result.map((item) => {
      const key = item.TIPE_3 + ", " + item.TIPE_2 + ", " + item.TIPE_1;
      return {
        ...item,
        key,
        min: 0,
        max: 0,
        group: "poi",
      };
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "array_formula_insight",
        value: array_formula_insight,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "template_poi",
    });
  } catch (error) {}
};

export const gen_demo_ss = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "template_demo",
    });
    const state = getState();
    let { prompt_ss, array_formula_insight } = state.insight_reducer;
    const body = {
      prompt_ss,
      manifest_demography,
    };
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      bun_server + `/sini_v2/ss_formula/gen_demo_ss`,
      body,
      config
    );
    const data = res?.data;
    let result = data?.result || [];
    const response = data?.response || "";
    result = result.map((item) => {
      return {
        ...item,
        group: "demography",
      };
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "response_ai_demo",
        value: response,
      },
    });
    array_formula_insight = [...array_formula_insight, ...result];
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "array_formula_insight",
        value: array_formula_insight,
      },
    });
    dispatch({
      type: "set_value_insight",
      payload: {
        key: "response_ai_demo",
        value: response,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "template_demo",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "gen_demo_ss",
    });
  }
};
